// Sent verbatim by scribe (apis_internal/billing/client.go) and the only thing
// separating an unpaid subscription from a refused caller — both answer 403.
export const SCRIBE_TRANSCRIPTION_DISABLED = 'transcription is disabled';

export class TranscriptorApiError extends Error {
  constructor(
    message: string,
    public code?: string,
    public details?: unknown,
    public statusCode?: number,
  ) {
    super(message);
    this.name = 'TranscriptorApiError';
  }
}

// Tagged on the error the moment a response is turned into one, so every flow
// that consumes transcription — create, upload, start recording, reprocess —
// carries the reason. `statusCode` does not survive a rejected thunk (Redux
// serializes an error down to name/message/stack/code), `code` does.
export const TRANSCRIPTION_DISABLED_CODE = 'TRANSCRIPTION_DISABLED';

export const HTTP_ERROR_CODE = 'HTTP_ERROR';

export const transcriptorErrorCode = (
  statusCode: number,
  message: string,
): string =>
  statusCode === 403 && message === SCRIBE_TRANSCRIPTION_DISABLED
    ? TRANSCRIPTION_DISABLED_CODE
    : HTTP_ERROR_CODE;
